export default {"src":"/_next/static/media/download.6b87c727.svg","height":11,"width":9,"blurWidth":0,"blurHeight":0};